import { Navigate } from 'react-router-dom'

/**
 * Biometric Records is a report-only submodule matching legacy Students.aspx:612 and Attendance.aspx.
 * Any direct navigation to entry redirects smoothly to the live records list.
 */
export default function BiometricRecordsEntryScreen() {
  return <Navigate to="/admission/biometric-records/list" replace />
}
